export const toloadMsgCount = 8
export const facebookAppId_prod = '314020570644892'
export const facebookAppId_dev = '5202956746432566'
export const FacebookLogin_scope='pages_manage_metadata,instagram_basic,instagram_manage_messages,pages_messaging,pages_manage_engagement,pages_manage_posts,pages_read_engagement,pages_read_user_content,instagram_manage_comments,leads_retrieval'
export const fetchFacebookFeedPostAfterMiliSec=5000
export const ON_DISCONNECT_TRY_RECONNECT_TIMEOUT = 5000
export const MAX_RECONNECT_ATTEMPTS = 12
// export const SERVER_URL_DEV = 'https://dev.effective-oc.com:6006'
// export const SERVER_URL_PROD = 'https://effective-oc.com:6006'
export const SERVER_URL_DEV = 'https://sv1.effective-oc.com'
export const SERVER_URL_PROD = 'https://sv1.effective-oc.com'
export const multipleMsgChunkSize = 500;
export const allowedApiChannels = ['whatsapp','sms','mail','instagram','ig_media','messenger','facebook']
export const googleAuthScopes = 'https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.force-ssl'
export const googleClientId = '675967507978-ns6vlj6o4din29fnlq8i18dca9qg10gu.apps.googleusercontent.com'
export const batchImportContacts = 1000;
export const allSupportTypes = ".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.pptx,.ppt,.mp3,.wav,.ogg,.mp4,.aac,.txt,.csv,.xls,.xlsx,.m4a" 
export const sendMediaSupportedTypes = {
    whatsapp: allSupportTypes,
    sms: "",
    instagram: ".gif,.jpg,.jpeg,.png",
    messenger: ".gif,.jpg,.jpeg,.png,.pdf,.mp3,.wav,.ogg,.mp4",
    mail: allSupportTypes,
    company: allSupportTypes,
    facebook: ".gif,.jpg,.jpeg,.png",
    ig_media: ".gif,.jpg,.jpeg,.png,.mp4"
}
export const PBX_SUPPORT_ACTIONS = {
    'MAKE_CALL': ['broadworks', 'itc-panasonic-kxtda','effective-dialers'],
    'ANSWER_CALL': ['broadworks', 'itc-panasonic-kxtda','effective-dialers'],
    'RELEASE_CALL': ['broadworks', 'itc-panasonic-kxtda','effective-dialers'],
    'TRANSFER_CALL': ['broadworks','effective-dialers'],
    'CONFERENCE_CALL': ['broadworks','effective-dialers'],
    'HOLD_CALL': ['broadworks','effective-dialers'],
    'CHECK_ACTIVE_CALLS': ['broadworks','effective-dialers'],
    'RECONNECT_PBX': ['broadworks', 'itc-panasonic-kxtda','effective-dialers']
}

//Permission on standby: ,instagram_content_publish

export const itemsPerPagePagination = 9


// Start File Manager
export const FILE_MANAGER_PER_PAGE_ITEMS = 12
export const FILE_MANAGER_MAX_LOAD_FILES = 100
export const FILE_DELAY_LOAD_PAGE_MS = 500
export const FILE_MAX_UPLOAD_COUNT = 5
export const FILE_MAX_UPLOAD_SIZE_MB = 20
export const FILE_MAX_SELECT_FILES_COUNT = 12
export const REFRESH_MEDIA_TOKEN_IN_SEC = 50
export const MAIN_SEARCH_DEBOUNCE_DELAY_MS = 500 //debounce
// End File Manager

export const CHECK_ACTIVE_CALLS_INTERVAL_MS = 60000

export const MAX_PBX_RECONNECT_ATTEMPTS = 5
export const RECONNECT_TIME_OUT_SEC = 60
export const FETCH_AGENTS_INTERVAL_SEC = 600

export const LIMIT_ITEMS_PER_PAGE = 50